import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, isRef as _isRef, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/header.png'


const _withScopeId = n => (_pushScopeId("data-v-3e1982fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex w-full mx-auto h-screen bg-gradient-to-t from-bg-primary-dark to-bg-primary text-text-color overflow-hidden" }
const _hoisted_2 = {
  key: 0,
  class: "loading-div"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "helper" }, null, -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "auth-container m-auto flex flex-col gap-y-2 items-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header flex justify-center p-2" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "logo",
      src: _imports_0
    })
  ])
], -1))
const _hoisted_8 = { class: "auth-form w-full" }
const _hoisted_9 = ["onSubmit"]
const _hoisted_10 = {
  key: 0,
  class: "error text-red-500 text-center font-bold"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-group my-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm mb-4 block" }, "Enter your email to receive a reset password link.")
], -1))
const _hoisted_12 = { class: "form-group my-2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-group my-2" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "w-full bg-link-color text-white px-3 py-2 rounded-lg focus:outline-none",
    type: "submit"
  }, "Send Reset Link")
], -1))
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-group my-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm mb-4 block" }, "A link was sent to your email!")
], -1))
const _hoisted_16 = { class: "auth-links center w-full" }

import { ref } from "@vue/reactivity"
import { auth } from "../firebase/config";
import FirebaseUtil from '../firebase/FirebaseUtil';
import { FirebaseError } from '@firebase/util';
import { getAuth, sendPasswordResetEmail } from "firebase/auth";


export default /*#__PURE__*/_defineComponent({
  __name: 'ResetPasswordView',
  setup(__props) {

const linkSent = ref(false)
const error = ref('')
const email = ref(null)
const showEmailError = ref(false)
const isLoading = ref(false)
const firebaseUtilObj= new FirebaseUtil()

const resetPassword = async (event)=>{

    isLoading.value = true

    try{
        await sendPasswordResetEmail(auth, email.value)

        // Password reset email sent!
        linkSent.value = true
    }
    catch (err: any)
    {
        //error signing in
        if(err instanceof FirebaseError)
            error.value = firebaseUtilObj.handlerError(err)
        else
            error.value = err.message;            
    } 
    finally
    {
        isLoading.value = false
    }

    

}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    (_unref(isLoading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        (!_unref(linkSent))
          ? (_openBlock(), _createElementBlock("form", {
              key: 0,
              onSubmit: _withModifiers(resetPassword, ["prevent"])
            }, [
              (_unref(error))
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(error)), 1))
                : _createCommentVNode("", true),
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass(["focus:outline-none rounded-md px-3 py-1 w-full", {'input-error':_unref(showEmailError)}]),
                  name: "email",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(email) ? (email).value = $event : null)),
                  type: "email",
                  placeholder: "Email",
                  required: "",
                  autocomplete: "false"
                }, null, 2), [
                  [_vModelText, _unref(email)]
                ])
              ]),
              _hoisted_13
            ], 40, _hoisted_9))
          : (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_router_link, {
                  class: "w-full block text-center bg-link-color text-white px-3 py-2 rounded-sm focus:outline-none",
                  to: {name:'login'}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Return to login")
                  ]),
                  _: 1
                })
              ])
            ]))
      ])
    ])
  ]))
}
}

})